import React from 'react';
import Chart from 'react-apexcharts';
import {formatNumberAsCurrency} from 'utils/helpers'

const Doughnut = ({series}) => {
  const options = {
    chart: {
      type: 'donut',
    },
    plotOptions: {
      pie: {
        donut: {
          size: '55%',
        },
        size: 10,
      },
    },
    maintainAspectRatio: false,
    legend: {
      show: false,
    },
    hover: {
      filter: {
        type: 'none',
      },
    },
    dataLabels: {
      style: {
        fontSize: '10px',
        fontFamily: 'Helvetica, Arial, sans-serif',
        fontWeight: 'bold',
      },
    },
    colors: ['#77B9CE', '#b32e2e'],
    // responsive: [
    //   {
    //     breakpoint: 480,
    //     options: {
    //       chart: {
    //         //width: 400,
    //       },
    //       legend: {
    //         position: 'bottom',
    //       },
    //     },
    //   },
    // ],
    tooltip: {
      custom: function ({ series, seriesIndex, dataPointIndex, w }) {
        //this is a hack...would clean this up later
        const labels = [
          // 'Total Allocation',
          'Recurrent Expenditure',
          'Capital Expenditure',
        ];
        return (
          '<div class="arrow_box">' +
          '<span>' +
          // w.globals.labels[seriesIndex] +
          labels[seriesIndex] +
          ': ' +
          formatNumberAsCurrency(series[seriesIndex],2) +
          '</span>' +
          '</div>'
        );
      },
    },
  };
 
  return (
    <div>
      <Chart options={options} series={series} type="donut" />
    </div>
  );
};

export default React.memo(Doughnut);
